// extracted by mini-css-extract-plugin
export var alt = "MediaCta-module--alt--067e6";
export var container = "MediaCta-module--container--2689e";
export var desktopOnly = "MediaCta-module--desktopOnly--ff0ad";
export var main = "MediaCta-module--main--83b91";
export var mobileOnly = "MediaCta-module--mobileOnly--b33c5";
export var textLeft = "MediaCta-module--textLeft--c0fbe";
export var title = "MediaCta-module--title--0fbce";
export var visuallyHidden = "MediaCta-module--visuallyHidden--49422";